import { render, staticRenderFns } from "./BalanceHeader.vue?vue&type=template&id=c3806d2a"
import script from "./BalanceHeader.vue?vue&type=script&lang=js"
export * from "./BalanceHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports